const {
    googleClientId,
    telemetryApi,
    portalApi,
    masterDataApi,
    sagTempUi,
    calibrationPlatformApi,
    deviceUtilityApi,
    qsUserAnalyticsUrl,
    googleApiDeveloperKey,
    mapBoxAccessToken,
    appsmithPages,
    tenxDeviceAdminApi
} = window.env || {};

const apiMap = {
    portal: portalApi,
    telemetry: telemetryApi,
    masterdata: masterDataApi,
    calibration: calibrationPlatformApi,
    deviceUtility: deviceUtilityApi,
    tenxDeviceAdmin: tenxDeviceAdminApi
};

const getResourceUrl = (resource) => {
    const [apiName, resourceName, resourceType] = resource.split("/");

    if (Object.prototype.hasOwnProperty.call(apiMap, apiName)) {
        return {
            apiName,
            resource: resourceName,
            resourceType,
            apiUrl: apiMap[apiName],
        };
    }

    return {
        apiName,
        resource,
        apiUrl: portalApi,
    };
};

const getApiUrl = (resource) => {
    if (Object.prototype.hasOwnProperty.call(apiMap, resource)) {
        return apiMap[resource];
    } else {
        return portalApi;
    }
};

export const config = {
    apiUrl: portalApi,
    googleClientId,
    sagTempUiUrl: sagTempUi,
    calibrationPlatformAPIUrl: calibrationPlatformApi,
    deviceUtilityApi: deviceUtilityApi,
    qsUserAnalyticsUrl,
    appsmithPages,
    getResourceUrl,
    getApiUrl,
    googleApiDeveloperKey,
    mapBoxAccessToken,
};
